const Components = require('./js/components');

module.exports = {
  Components,
  Mixins: require('./js/mixins'),
  Utils: require('./js/utils'),
  shim: require('./js/shim'),
  ...Components,
};
